import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { DetectionTestBase } from "../DetectionTestBase";

interface Props {
  isDailyAccessible: boolean;
  isRequiredChecksLoading: boolean;
  hasDivider?: boolean;
}

const DailyDetectionError = ({
  isDailyAccessible,
  isRequiredChecksLoading,
  hasDivider = false,
}: Props): JSX.Element | null => {
  const { t } = useI18n(["micCamCheck", "url"]);

  if (isRequiredChecksLoading || isDailyAccessible) {
    return null;
  }

  return (
    <DetectionTestBase
      testName={t("micCamCheck:daily.failure")}
      testResult={
        <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
          {t("micCamCheck:daily.failure.message")}
        </Typography>
      }
      troubleShootLink={t("url:troubleshoot.firewall")}
      showTroubleshootLink
      hasDivider={hasDivider}
      isLoading={isRequiredChecksLoading}
    />
  );
};

export default DailyDetectionError;
